import { Loader } from 'components/ApplicationLoader';
import { 
  FETCH_JOURNEYS_REQUEST,
  FETCHING_JOURNEYS_FAILED,
  FETCH_JOURNEY_REQUEST,
  FETCHING_JOURNEY_FAILED,
  CREATE_JOURNEY_REQUEST,
  CREATE_JOURNEY_FAILED,
  UPDATE_JOURNEY_REQUEST,
  UPDATING_JOURNEY_FAILED,
  DELETE_JOURNEY_REQUEST,
  DELETING_JOURNEY_FAILED,
  CREATE_JOURNEY_SUCCEDDED,
  FETCHING_JOURNEY_SUCCEDDED,
  FETCHING_JOURNEYS_SUCCEDDED,
  DELETING_JOURNEY_SUCCEDDED,
  UPDATING_JOURNEY_SUCCEDDED,
  CREATE_JOURNEY_STEP,
  CREATE_JOURNEY_STEP_SUCCEDDED,
  CREATE_JOURNEY_STEP_FAILED,
  UPDATE_JOURNEY_STEP,
  UPDATING_JOURNEY_STEP_SUCCEDDED,
  UPDATING_JOURNEY_STEP_FAILED,
  DELETE_JOURNEY_STEP,
  DELETING_JOURNEY_STEP_SUCCEDDED,
  DELETING_JOURNEY_STEP_FAILED,
  FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED,
  FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST,
  FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED,
  INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS,
  UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER,
  UPDATE_JOURNEY_DATA_REQUEST
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  fetched: false,
  error: null,
  invalidated: false,
  creating: false,
  cloning: false,
  items: [],
  pagination: {
    currentPage: 0,
    totalPages: 0,
    recordsPerPage: 10,
    totalRecordsCount: 0
  },
  contentManager: {
    id:null,
    items: [],
    filters: [],
    pagination: {
      current: -1,
      totalPages: 1 
    }
  }
}

const initialJourneyState = {
  loading: false,
  start: null,
  createdBy: {},
  disabled: false,
}

const initialJourneyStep = {
  loading: false,
  id: null,
  name: null,
  start: null,
  disabled: true,
  steps:[],
  connectors: []
}

const initialMappingState = {
  pagination: {
    current: -1,
    totalPages: 1
  },
  loading: false,
  items: []
}


export function journeyReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_JOURNEYS_REQUEST: {

      return {
        ...state,
        loading: true,
        fetched: false
      }
    }

    case FETCHING_JOURNEYS_SUCCEDDED: {
      var { currentPage, totalPages, recordsPerPage, totalRecordsCount, records = [] } = action.payload;
      var items = [];

      if (currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }
      return {
        ...state,
        loading: false,
        fetched: true,
        items: items,
        pagination: {
          ...state.pagination,
          current: currentPage,
          totalPages: totalPages,
          totalRecordsCount: totalRecordsCount
        }
      }
    }

    case FETCHING_JOURNEYS_FAILED: {
      const { error }  = action.payload;

      return {
        ...state,
        loading: false,
        fetched: false,
        error: error
      }
    }

    // case INVALIDATE_JOURNEYS: {
    //   return {
    //     ...state,
    //     loading: false,
    //     fetched: false,
    //     items: []
    //   }
    // }

    case FETCH_JOURNEY_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        [id]: {
          ...initialJourneyState,
          loading: true,
        }
      }
    }

    case FETCHING_JOURNEY_SUCCEDDED: {
      var { id, response } = action.payload;

      return {
        ...state,
        [id]: {
          loading: false,
          ...response
        }
      }
    }

    case FETCHING_JOURNEY_FAILED: {
      var { id, error } = action.payload;

      return {
        ...state,
        [id]: {
          loading: false,
          error: error
        }
      }
    }

    case CREATE_JOURNEY_REQUEST: {
      return {
        ...state,
        creating: true
      }
    } 

    case CREATE_JOURNEY_SUCCEDDED: {
      const response  = action.payload;
      
      const id = response.id;
      // const pageState = state.page[response.id] || initialJourneyState;

      var journeys = [action.payload, ...state.items];

      return {
        ...state,
        creating: false,
        items: journeys,
      }
    }

    case CREATE_JOURNEY_FAILED: {
      const error = action.payload;

      return {
        ...state,
        creating: false,
        error: error
      }
    }

    case UPDATE_JOURNEY_DATA_REQUEST: {
      const { id, request }  = action.payload;
      const journeyState = _.get(state, `${id}`) || initialJourneyStep;

      return {
        ...state,
        [id]:{
          ...journeyState,
          ...request
        }
      }
    }


    case UPDATE_JOURNEY_REQUEST: {
      const { id }  = action.payload;


      const journeyState = _.get(state, `${id}`) || initialJourneyStep;

      return {
        ...state,
        [id]:{
          ...journeyState,
          updating: true,
        }
      }
    }

    case UPDATING_JOURNEY_SUCCEDDED: {
      const { id, response }  = action.payload;
      var journeyDetail = _.get(state, 'items', []);
      var triggerAsset = (response?.steps || []).filter(item => {
        return item.start == true;
      });
      const isManualNode = _.get(triggerAsset[0], 'mappingType', "") == 'MANUAL'
      const triggerAssetName = isManualNode ? _.get(triggerAsset[0], 'mapping.asset.name', "") : _.get(triggerAsset[0], 'description', "");
      journeyDetail = journeyDetail.map((journey) => {
        if(journey.id === id) {
          return {
            ...journey,
            name: response.name,
            disabled: response.disabled,
            trigger: triggerAssetName
          }
        }
        return journey;
      });
      return {
        ...state,
        items: journeyDetail,
        [id]: response
      }
    }

    case UPDATING_JOURNEY_FAILED: {
      const { id, error }  = action.payload;
      
      const journeyState = _.get(state, `${id}`) || initialJourneyStep;

      return {
        ...state,
        error: error,
        [id]:{
          ...journeyState,
          error: error,
          updating: false,
        }
      }
    }

    case DELETE_JOURNEY_REQUEST: {
      const { id } = action.payload;

      return {
        ...state,
        deletion: {
          deleting: true,
          deleted: false,
          id: id
        }
      }
    }
  
    case DELETING_JOURNEY_SUCCEDDED: {
      const { id } = action.payload;

      if(id !== state.deletion.id) {
        return state;
      }

      var updatedJourney = (state.items || []).filter(item => {
        return item.id !== id;
      });

      return {
        ...state,
        items: updatedJourney,
        deletion: {
          deleting: false,
          deleted: true,
          id: id
        }
      }
    }

    case DELETING_JOURNEY_FAILED: {
      const { id, error } = action.payload;

      if(id !== state.deletion.id) {
        return state;
      }

      return {
        ...state,
        page: {
          ...state.page,
          deletion: {
            ...state.deletion,
            deleting: false,
            deleted: false,
            id:id,
            error: error
          }
        }
      }
    }

    case CREATE_JOURNEY_STEP: {
      const { journeyId, selectedNode, request }  = action.payload;
      if(!journeyId) {
        return state;
      }

      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

      return {
        ...state,
        [journeyId]: {
          ...journeyState,
          steps: [
            ...journeyState.steps,
            {
              uid: selectedNode,
              loading: true,
              mappings:null,
              filters: request.type == 'CONDITION' ? request.commands :[],
            }
          ]
        }
      }
    }

    case CREATE_JOURNEY_STEP_SUCCEDDED: {
      const { journeyId, response, selectedNode }  = action.payload;

      if(!journeyId) {
        return state;
      }

      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

      let journeyStep = _.get(journeyState, 'steps', []);
      journeyStep = journeyStep.map((step) => {
        if(step.uid === selectedNode) {
          return {
            ...step,
            loading: false,
            ...response
          }
        }

        return step;
      });

      return {
        ...state,
        [journeyId]:{
          ...journeyState,
          loading: false,
          steps: journeyStep
        }
      }
    }

    case CREATE_JOURNEY_STEP_FAILED: {
      const { journeyId, error }  = action.payload;
    
      if(!journeyId) {
        return state;
      }

      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

      return {
        ...state,
        [journeyId]:{
          ...journeyState,
          steps:[]
        }
      }
    }

    case UPDATE_JOURNEY_STEP: {
      const { journeyId, selectedNode, request }  = action.payload;
      if(!journeyId) {
        return state;
      }

      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

      let updatedJourneyStep = _.get(journeyState, 'steps', []);
        updatedJourneyStep = updatedJourneyStep.map((step) => {
        if(step.id === selectedNode) {
          return {
            ...step,
            updating: true,
            filters: request.type == 'CONDITION' ? request.commands :[],
          }
        }

        return step;
      });

      return {
        ...state,
        [journeyId]: {
          ...journeyState,
          steps: updatedJourneyStep
        }
      }
    }

    case UPDATING_JOURNEY_STEP_SUCCEDDED: {
      const { journeyId, response, selectedNode }  = action.payload;
      if(!journeyId) {
        return state;
      }

      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

      let updatedJourneyStep = _.get(journeyState, 'steps', []);
      updatedJourneyStep = updatedJourneyStep.map((step) => {
        if(step.id === selectedNode) {
          return {
            ...step,
            ...response
          }
        }

        return step;
      });

      return {
        ...state,
        [journeyId]: {
          ...journeyState,
          steps: updatedJourneyStep
        }
      }
    }

    case UPDATING_JOURNEY_STEP_FAILED: {
      const { journeyId, error }  = action.payload;
      if(!journeyId) {
        return state;
      }
      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;
      

      return {
        ...state,
        [journeyId]: {
          ...journeyState,
          error: error
        }
      }
    }

    case DELETE_JOURNEY_STEP: {
      const { journeyId, deleteRequest }  = action.payload;
      
      if(!journeyId) {
        return state;
      }
      
      const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep; 

      let updatedJourneyStep = _.get(journeyState, 'steps', []);
      updatedJourneyStep = _.filter(updatedJourneyStep, step => {
        const shouldDelete = _.includes(deleteRequest, step.id);
        return !shouldDelete; // Keep steps that are not included in deleteMappings
      });

      return {
        ...state,
        [journeyId]: {
          ...journeyState,
          steps: updatedJourneyStep
        }
      }
    }

    // case DELETING_JOURNEY_STEP_SUCCEDDED: {
    //   const { journeyId, response }  = action.payload;
      
    //   if(!journeyId) {
    //     return state;
    //   }

    //   const journeyState = _.get(state, `${journeyId}`) || initialJourneyStep;

    //   let updatedJourneyStep = _.get(journeyState, 'steps', []);
    //   updatedJourneyStep = _.filter(updatedJourneyStep, (data)=>{return data.id !});

    //   return {
    //     ...state,
    //     [journeyId]: {
    //       ...journeyState,
    //       steps: updatedJourneyStep
    //     }
    //   }
    // }

    // case DELETING_JOURNEY_STEP_FAILED: {
    //   const { journeyId, error }  = action.payload;
      
    //   return {
    //     ...state,
    //   }
    // }

    case FETCH_FILTER_MAPPINGS_FOR_JOURNEY_REQUEST: {
      const { journey }  = action.payload;

      return {
        ...state,
        contentManager: {
          ...state.contentManager,
          id: journey,
          loading: true,
        }
      }
    }

    case FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_SUCCEEDED: {
        const { journey, response } = action.payload;

        if (journey !== state.contentManager.id) {
          return state;
        }

        let items = _.get(state, 'contentManager.items') || [];

        if (response.currentPage !== 0) {
          items = [...items, ...response.records];
        } else {
          items = [...response.records]
        }

        items = _.uniqBy(items, 'id');

        return {
          ...state,
          contentManager: {
            ...state.contentManager,
            loading: false,
            items: items,
            pagination: {
              ...initialMappingState.pagination,
              current: response.currentPage,
              totalPages: response.totalPages,
              totalRecordsCount: response.totalRecordsCount
            }
          }
        }
    }

    case FETCHING_FILTER_MAPPINGS_FOR_JOURNEY_FAILED: {
      const { journey, error } = action.payload;

      if (journey !== state.contentManager.id) {
        return state;
      }

      return {
        ...state,
        contentManager: {
          ...state.contentManager,
          loading: false,
          error: error
        }
      }
    }

    case UPDATE_JOURNEY_DYNAMIC_CONTENT_MANAGER: {
      const { request } = action.payload;

      return {
        ...state,
        contentManager: {
          ...state.contentManager,
          ...request
        }
      }
    }


    case INVALIDATE_JOURNEY_CONTENT_MANAGER_MAPPINGS: {
      return {
        ...state,
        contentManager: _.cloneDeep(initialState.contentManager)
      }
    }

    default:
      return state;
  }
}